import { UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const vendorSchema = {
    displayName: 'vendor',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        isDefault: {
            type: 'bool',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        userIds: {
            type: 'array',
            elementType: 'mongoId',
            displayName: 'Users',
            ui: 'table',
            placeholder: 'Select Users with Access to this Vendor',
            required: true,
            biteOnly: true,
        },
        name: {
            type: 'shortString',
            required: true,
            writeRight: UserRight.ManageMenu,
        },
        logoImage: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            displayName: 'Logo Image',
            keepAspectRatio: 'contain',
            size: {
                width: 320,
                height: 224,
            },
            tooltip: {
                text: 'Image to be used in page buttons and other UI.',
            },
            writeRight: UserRight.ManageMenu,
        },
        pickUpText: {
            type: 'longString',
            displayName: 'Food Pick-up Instructions',
            tooltip: {
                text: 'Short text to tell guests where to find their order. ex: Window 2',
            },
            writeRight: UserRight.ManageMenu,
        },
        showVendorAsClosedIfNoMenuSectionsAreActive: {
            type: 'bool',
            displayName: 'Show this vendor as closed if it has no active menu sections',
            tooltip: {
                text: `If enabled, and none of this vendor's menu sections are active, then show this vendor's page as closed with all the menu items disabled.`,
            },
            writeRight: UserRight.ManageMenu,
        },
    },
};
//# sourceMappingURL=vendor_schema.js.map